import { BRAND } from '../../../core/constants/site';

import './styles/BrandMark.css';

export default function BrandMark({ onClick }) {
    return (
        <a className="brand-mark" href="/" onClick={onClick}>
            <img
                className="brand-mark__ring"
                src="/img/logo-72.webp"
                srcSet="/img/logo-72.webp 2x, /img/logo-144.webp 3x"
                width="36"
                height="36"
                alt=""
            />
            <span className="brand-mark__text">
                <span className="brand-mark__name">{BRAND.name}</span>
                <span className="brand-mark__descriptor">{BRAND.descriptor}</span>
            </span>
            <span className="sr-only">, ir al inicio</span>
        </a>
    );
}
